import React from 'react';
import theme, { cn } from '../../styles/theme';

const PagoClienteItem = ({ pagoc, onEdit, onViewSucursales }) => {
  const getBadgeStyles = (estado) => {
    return estado === 'ACTIVO' 
      ? theme.classes.status.active
      : theme.classes.status.inactive;
  };

  const getStatusIcon = (estado) => {
    return estado === 'ACTIVO' ? (
      <svg className="w-3 h-3 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      </svg>
    ) : (
      <svg className="w-3 h-3 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
      </svg>
    );
  };

  

  const getImageUrl = (imagen) => {
    if (!imagen) return null;
    if (imagen.startsWith('data:') || imagen.startsWith('http')) {
      return imagen;
    }
    return `data:image/jpeg;base64,${imagen}`;
  };

  const PagoImage = ({ imagen }) => {
    const imageUrl = getImageUrl(imagen);
    
    if (!imageUrl) {
      return (
        <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
      );
    }

    return (
      <div className="relative group">
        <img
          src={imageUrl}
          alt={'Pago'}
          className={cn(
            "w-16 h-16 object-cover rounded-lg border border-gray-200",
            theme.shadows.sm,
            "group-hover:shadow-md",
            theme.transitions.default
          )}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <div 
          className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center absolute top-0 left-0"
          style={{ display: 'none' }}
        >
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 15.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        
        <div className={cn(
          "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100",
          theme.transitions.default
        )}>
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>
    );
  };

  return (
    <tr className={cn(theme.classes.table.row)}>
      {/* Columna ID */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-mono font-semibold text-gray-900 bg-gray-100 px-2 py-1 rounded">
            #{pagoc.Id_pagoc}
          </div>
        </div>
      </td>

      {/* Columna Imagen */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center justify-center">
          <PagoImage 
            imagen={pagoc.Imagen} 
           
          />
        </div>
      </td>

     
      {/* Columna Descripción */}
      <td className="px-6 py-4">
        <div className="flex items-start">
          <div className="max-w-xs">
            <p className="text-sm text-gray-900 leading-relaxed line-clamp-2">
              {pagoc.Descripcion || 'Sin descripción'}
            </p>
            <div className="text-xs text-gray-500 mt-1">
              Descripción
            </div>
          </div>
        </div>
      </td>

           

      {/* Columna Estado
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <span className={cn("inline-flex items-center px-3 py-1 rounded-full text-xs font-medium", getBadgeStyles(producto.Estado))}>
            {getStatusIcon(producto.Estado)}
            {producto.Estado}
          </span>
        </div>
      </td> */}

      {/* Columna Acciones */}
      <td className="px-6 py-4 whitespace-nowrap text-right">
        <div className="flex items-center justify-end gap-2">
          {/* Botón Editar */}
          {/* <button
            onClick={() => onEdit(producto)}
            className={cn(
              "group relative inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-1",
              theme.transitions.default
            )}
            title="Editar producto"
          >
            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar
            
            
            <span className={cn(
              "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap",
              theme.transitions.default
            )}>
              Modificar este Producto
            </span>
          </button> */}

          {/* Botón de menú de opciones adicionales */}
          <button
            className={cn(
              "group relative inline-flex items-center justify-center p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg",
              theme.transitions.default
            )}
            title="Más opciones"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
            
            <span className={cn(
              "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap",
              theme.transitions.default
            )}>
              Más acciones
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default PagoClienteItem;